import dayjs from 'dayjs'

import { Challenge } from '../../types'

export const REDESIGN_INITIAL_CHALLENGE: Challenge = {
  title: '',
  description: '',
  category: '',
  hashtags: [],
  instructions: '',
  startDate: dayjs().format('YYYY-MM-DD'),
  endDate: dayjs().format('YYYY-MM-DD'),
  image: null,
  altText: '',
  participants: [],
  points: 1,
  visibility: true,
}
